import { render, staticRenderFns } from "./ChatOrderFreeProductItem.vue?vue&type=template&id=d3f8f15a&scoped=true&"
import script from "./ChatOrderFreeProductItem.vue?vue&type=script&lang=js&"
export * from "./ChatOrderFreeProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderFreeProductItem.vue?vue&type=style&index=0&id=d3f8f15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f8f15a",
  null
  
)

export default component.exports